{
  "WALLBOARD": {
    "LOADING": "جارٍ تحميل قوائم انتظار الهاتف...",
    "NO_QUEUES": "لم يتم العثور على قوائم انتظار للهاتف.",
    "NO_AGENTS": "لا يوجد وكلاء متصلون في قائمة الانتظار هذه.",
    "UNKNOWN_CALLER": "متصل غير معروف",
    "STATUS": "الحالة",
    "TIME": "الوقت",
    "AGENT": "الوكيل",
    "EXTENSION": "الرقم الداخلي",
    "READY": "الوكلاء الجاهزون",
    "ON_CALL": "الوكلاء في مكالمة",
    "PAUSED": "الوكلاء في استراحة",
    "WAITING": "المكالمات المنتظرة",
    "MISSED_CALLS": "المكالمات الفائتة",
    "HANDLED_CALLS": "المكالمات الواردة التي تمت معالجتها",
    "OUTBOUND_CALLS": "المكالمات الصادرة التي تمت معالجتها",
    "AVAILABILITY": "التوافر",
    "AVAILABILITY_TOOLTIP": "نسبة المكالمات الواردة التي أجاب عليها الوكلاء (المكالمات التي تم الرد عليها)",
    "AGENTS_COUNT": "({onCall} في مكالمة / {total} الإجمالي)",
    "NO_AVAILABLE": "(لا أحد متصل)",
    "WAITING_CALLERS_COUNT": "{count} في الانتظار",
    "CALLER": "المتصل",
    "NUMBER": "الرقم",
    "WAIT_TIME": "وقت الانتظار",
    "ACTION": "الإجراء",
    "PICKUP_CALL": "الرد",
    "PICKUP_SUCCESS": "تم طلب الرد على المكالمة بنجاح.",
    "PICKUP_ERROR": "تعذّر الرد على المكالمة. يرجى المحاولة مرة أخرى.",
    "PICKUP_DISABLED_TOOLTIP": "لا يمكنك الرد على مكالمة أثناء وجودك في مكالمة أخرى أو أثناء عدم الاتصال.",
    "CHAT_STATUS": {
      "NO_ACCESS": "لا توجد صلاحية وصول"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "لا توجد صلاحية وصول"
    }
  }
}
